import { useState } from 'react';

const useOutsideClickAnimation = (backdrop: boolean | 'static', onClose: () => void) => {
    const [bouncingAnimation, setBouncingAnimation] = useState(false);

    const onBackdropClick = () => {
        if (backdrop === 'static') {
            setBouncingAnimation(true);

            setTimeout(() => {
                setBouncingAnimation(false);
            }, 250);

            return;
        }

        onClose();
    };

    return { onBackdropClick, bouncingAnimation };
};

export default useOutsideClickAnimation;
